import type { ReactElement } from 'react';
import { PiStat, PiStatGrid, piCount } from '../pi-kit';
import type { ChallengesView } from './challenges-model';

/**
 * Challenge Hub headline: four tiles from the server's `overall` block.
 * Participants (editions as detail), Winners (finalists as detail), Later
 * applied and Later admitted (the at-partner-school count as detail). Every
 * other figure lives on the edition cards. Errors are rendered by the page.
 */

export function ChallengesOverview({
  data,
  loading,
}: {
  data: ChallengesView | null;
  loading: boolean;
}): ReactElement {
  const overall = data?.overall ?? null;
  const busy = loading && data === null;
  const detail = (text: string) => (busy || overall === null ? undefined : text);

  return (
    <PiStatGrid>
      <PiStat
        label="Participants"
        value={piCount(overall?.participants)}
        detail={detail(`${piCount(overall?.editions)} editions`)}
        loading={busy}
      />
      <PiStat
        label="Winners"
        value={piCount(overall?.winners)}
        detail={detail(`${piCount(overall?.finalists)} finalists`)}
        loading={busy}
      />
      <PiStat
        label="Later applied"
        value={piCount(overall?.downstream.applied)}
        detail={detail(`${piCount(overall?.downstream.appliedAtPartner)} at partner schools`)}
        loading={busy}
      />
      <PiStat
        label="Later admitted"
        value={piCount(overall?.downstream.admitted)}
        detail={detail(`${piCount(overall?.downstream.admittedAtPartner)} at partner schools`)}
        loading={busy}
      />
    </PiStatGrid>
  );
}
